import {useEffect, useState} from 'react'
import {UserModel} from '../../auth'
import PendingOrdersCardRow from './PendingOrdersCardRow'
import { getPendingPOSInfo } from '../core/_requests'
import { IPendingPOSModel } from '../core/_models'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { getPurchaseReturnOrders } from '../../orders/core/_requests'
import { PO } from '../../orders/core/_models'
import { useSupplierInfo } from '../../../../_metronic/layout/core/SupplierInfoProvider'
import axios from 'axios'
import { Product } from '../../ordered-products/core/OrderedProductsModel'
import {API_URL} from '../../../tenant/apiBase'

type Props = {
  className: string
  language: string
  currentUser: UserModel | undefined
}

const ORDERED_PRODUCTS_URL = `${API_URL}/api/partner-portal/ordered-products`

const PendingOrdersCard: React.FC<Props> = ({language, currentUser, className}) => {
  const {formatMessage} = useIntl()
  const [state, setState] = useState<PO[]>([])
  const [pendingCount, setPendingCount] = useState<number>()
  const { supplierId } = useSupplierInfo()
  const [orderedProducts, setOrderedProducts] = useState<Product[]>([])

  useEffect(() => {
    const getData = async () => {
        try {
          const response = await axios.get<{data: Product[]}>(ORDERED_PRODUCTS_URL, {
            headers: {
              token: currentUser?.token || '',
              language,
            },
          })
          
          if (response.data && response.data.data) {
            const products = response.data.data.slice(0, 5)
            setOrderedProducts(products)
            setPendingCount(response.data.data.length)
          }
        } catch (error) {
          console.error('Error fetching ordered products:', error)
        }
    }
    getData()
  }, [supplierId, currentUser, language])

  return (
    <div className={className}>
      <div className='hsb-section-head'>
        <div className='d-flex align-items-center gap-3'>
          <h3 className='hsb-section-title'>{formatMessage({ id: "ORDERED_PRODUCTS.STATUS.PENDING" })}</h3>
          {pendingCount ? <span className='hsb-pill hsb-pill--error'>{pendingCount}</span> : null}
        </div>
        <span className='hsb-kpi-label'>{formatMessage({ id: "MENU.ORDERED_PRODUCTS" })}</span>
      </div>
      <div className='hsb-table-wrap'>
        <table className='hsb-table'>
          <thead>
            <tr>
              <th>{formatMessage({ id: "prod_name" }) || "Product Name"}</th>
              <th>{formatMessage({ id: "barcode" }) || "Barcode"}</th>
              <th className='hsb-td-center'>{formatMessage({ id: "qty" })}</th>
              <th className='hsb-td-end'>{formatMessage({ id: "status" }) || "Status"}</th>
            </tr>
          </thead>
          <tbody>
            {orderedProducts && orderedProducts.length > 0 ? (
              orderedProducts.map((product) => (
                <tr key={product.item_id}>
                  <td className='hsb-td-strong'>{product.product_name}</td>
                  <td className='hsb-td-mono'>{product.barcode}</td>
                  <td className='hsb-td-center hsb-td-strong'>{product.quantity}</td>
                  <td className='hsb-td-end'>
                    <span className='hsb-status' style={{ color: product.status_color }}>
                      {formatMessage({id: `ORDERED_PRODUCTS.STATUS.${product.item_status.toUpperCase()}`, defaultMessage: product.item_status})}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className='text-center py-4'>{formatMessage({ id: "no_data" })}</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className='hsb-table-foot'>
          <Link to="/ordered-products" className='hsb-foot-link'>
            {formatMessage({ id: "view_all" })}
            <span className='material-symbols-outlined'>open_in_new</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PendingOrdersCard
